module.exports = __webpack_public_path__ + "img/home.2274082c.png";